import moment from 'moment';
import React, { useState } from 'react';
import { NavDropdown, Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import store from 'store';
import Markdown from '../../util/markdown';
import browserHistory from '../../history';

const NavNotifications = ({ notifications = [], removeNote }) => {
  const [show, setShow] = useState('notes');
  const [toasts, setToasts] = useState(store.get('toasts'));

  const handleMarkAll = event => {
    event.preventDefault();
    event.stopPropagation();

    removeNote('all');
  };

  const handleMark = noteId => {
    removeNote(noteId);
  };

  const buildDateString = timestamp => {
    if (!timestamp) {
      return null;
    }

    return moment(timestamp).fromNow();
  };

  const renderTitle = () => {
    return (
      <div className="navbar-item-title">
        <i className="fas fa-bell fa-2x" />
        {notifications.length > 0 && <div className="count">{notifications.length}</div>}
      </div>
    );
  };

  const renderToasts = () => {
    if (!toasts || !toasts.length) {
      return [
        <Dropdown.Item className="note-body" key="empty">
          <div className="empty-set">Empty</div>
        </Dropdown.Item>,
      ];
    }

    return toasts.map(toast => {
      let note = {};
      try {
        note = JSON.parse(toast);
      } catch (err) {
        note = { title: 'Invalid Event' };
      }

      let toastBody = note.body || '';

      if (typeof toastBody === 'number') {
        toastBody = String(toastBody);
      } else if (!React.isValidElement(toastBody)) {
        if (typeof toastBody !== 'string') {
          if (toastBody && toastBody.props) {
            try {
              toastBody = React.cloneElement(toastBody);
            } catch (err) {
              console.warn(err);
              toastBody = 'Unknown';
            }
          } else {
            try {
              toastBody = JSON.stringify(toastBody);
            } catch (err) {
              console.warn(err);
              toastBody = 'Unknown';
            }
          }
        }
      }

      return (
        <Dropdown.Item className={classNames('note-body', { [note.type]: true })} key={note.id}>
          <div className="note-contents">
            <div className="note-timestamp">{buildDateString(note.timestamp)}</div>
            <span className="note-title">{note.title}</span>
            <br />
            <span className="note-desc">{toastBody}</span>
            <div className="note-location">
              <i className="fas fa-link" /> {note.location}
            </div>
          </div>
          <div className="clearfix" />
        </Dropdown.Item>
      );
    });
  };

  const renderNotifications = () => {
    // Handle empty state
    if (!notifications.length) {
      return [
        <Dropdown.Item className="note-body" key="empty">
          <div className="empty-set">All caught up!</div>
        </Dropdown.Item>,
      ];
    }

    const renderedNotes = notifications.map(note => {
      if (!note) {
        return false;
      }

      const handleLinks = event => {
        // allow any a tags to follow href attr else propagate to dropdown handler
        if (event.target.tagName === 'A') {
          event.stopPropagation();
        }
      };

      return (
        <Dropdown.Item
          className="note-body"
          key={note.id}
          onClick={() => {
            if (note.target) {
              browserHistory.push(note.target);
            }
          }}
        >
          <div className="note-contents">
            <div className="note-ctrls">
              <i
                className="fas fa-check"
                title="Mark as done"
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                  handleMark(note.id);
                }}
              />
            </div>
            <span className="note-title">{note.subject}</span>
            <br />
            <span className="note-desc">{new Date(note.createdAt).toDateString()}</span>
            <br />
            <span className="note-desc" onClick={handleLinks}>
              <Markdown>{note.message}</Markdown>
            </span>
          </div>
          <div className="clearfix" />
        </Dropdown.Item>
      );
    });

    // Add top menu controls
    renderedNotes.push(
      <Dropdown.Item className="toolbar" key="tb">
        <div className="note-contents">{`${notifications.length} notifications`}</div>
        <div className="note-ctrls">
          <i className="fad fa-check-double" title="Mark all as done" onClick={handleMarkAll} />
        </div>
        <div className="clearfix" />
      </Dropdown.Item>
    );

    return renderedNotes.reverse();
  };

  return (
    <NavDropdown
      id="notifications-dropdown"
      title={renderTitle()}
      className="top-level-menu no-caret d-none d-sm-block"
      onClick={() => setToasts(store.get('toasts'))}
      alignRight
    >
      <div className="notifications-wrapper">
        <div className={classNames('note-tab', { active: show === 'notes' })} onClick={() => setShow('notes')}>
          Notifications
        </div>
        <div className={classNames('note-tab', { active: show === 'toasts' })} onClick={() => setShow('toasts')}>
          Event History
        </div>
        {show === 'notes' && renderNotifications()}
        {show === 'toasts' && renderToasts()}
      </div>
    </NavDropdown>
  );
};

NavNotifications.propTypes = {
  notifications: PropTypes.array,
  removeNote: PropTypes.func,
};

export default NavNotifications;
